import React from 'react';
import PublicLayout from '../components/PublicLayout';
import FaqGrid from '../components/FaqGrid';
const h=React.createElement;
export default function Faq(props) {
  return h(PublicLayout,{page:'faq',isLoggedIn:props.isLoggedIn},
    h(FaqGrid,{isLoggedIn:props.isLoggedIn}));
}

